export function getEnabledStatusText(status: any) {
    if(status === 'y' || status === 'active' || status == 1 || status === true) {
        return 'Ativo';
    } else {
        return 'Inativo';
    }
}